export const lightenDarkenColor = (col, amt) => {
  var usePound = false;

  if (col[0] === '#') {
    col = col.slice(1);
    usePound = true;
  }

  var num = parseInt(col, 16);

  var r = (num >> 16) + amt;

  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  var b = ((num >> 8) & 0x00ff) + amt;

  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  var g = (num & 0x0000ff) + amt;

  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);
};

//Colors
export const LIGHT_GRAY_BLUE = '#eff3f6';
export const NORMAL_GRAY_BLUE = '#CFD5D9';
export const DARK_ENGLISH_RED = '#C31919';

export const BLACK = 'rgb(0,0,0)';
export const WHITE = 'rgb(255,255,255)';
export const RED = 'rgb(255,0,0)';
export const BLUE = 'rgb(0,0,255)';
export const GREEN = 'rgb(0,255,0)';
export const YELLOW = 'rgb(255,255,0)';
export const RED_TRANSPARENT = 'rgba(255,0,0,0.1)';
export const BLUE_TRANSPARENT = 'rgba(0,0,255,0.1)';
export const GREEN_TRANSPARENT = 'rgba(0,255,0,0.1)';
export const YELLOW_TRANSPARENT = 'rgba(255,255,0,0.1)';
